import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";

export default function DeleteConfirmModal({
  open,
  onClose,
  onConfirm,
  title = "Delete Post",
  description = "Are you sure you want to delete this post? This action cannot be undone.",
  confirmLabel = "Delete",
  // Override when "Cancel" would read as the destructive action itself, e.g.
  // a cancel-subscription dialog where both buttons would otherwise say cancel.
  cancelLabel = "Cancel",
  loading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { borderRadius: "16px", maxWidth: 400, mx: 2 } }}
    >
      <DialogTitle sx={{ fontWeight: 700, fontSize: "18px", color: "#111", pb: 0.5 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Typography sx={{ fontSize: "14px", color: "#0f172a" }}>
          {description}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            color: "#0f172a",
            bgcolor: "#ffffff",
            borderRadius: "10px",
            px: 2.5,
            borderColor: "#0f172a",
            borderWidth: 1,
            "&:hover": {
              bgcolor: "#f8fafc",
              borderColor: "#0f172a",
            },
            "&.Mui-disabled": {
              color: "#94a3b8",
              borderColor: "#e2e8f0",
              bgcolor: "#f8fafc",
            },
          }}
        >
          {cancelLabel}
        </Button>
        <Button
          onClick={onConfirm}
          disabled={loading}
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "10px",
            px: 2.5,
            minWidth: 80,
            bgcolor: "#ef4444",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.18), 0 2px 4px rgba(0, 0, 0, 0.08)",
            "&:hover": {
              bgcolor: "#dc2626",
              boxShadow: "0 6px 14px rgba(0, 0, 0, 0.2), 0 3px 6px rgba(0, 0, 0, 0.1)",
            },
            "&.Mui-disabled": {
              bgcolor: "#fca5a5",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.08)",
            },
          }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
